import { SharedState } from '@trello/shared-state';

export interface ClosedBoardsState {
  isLoading: boolean;
  hasError: boolean;
}

const initialState: ClosedBoardsState = {
  isLoading: false,
  hasError: false,
};

export const closedBoardsState = new SharedState<ClosedBoardsState>(
  initialState,
);
